<template>
  <DashboardLayout>
    <ScoresIndex />
    <div class="pb-16"></div>
  </DashboardLayout>
</template>

<script>
// @ is an alias to /src
import DashboardLayout from '@/layouts/DashboardLayout.vue';
import ScoresIndex from '@/components/dashboard/membersScores/ScoresIndex.vue';

export default {
  name: 'EmplyeesView',
  components: {
    DashboardLayout,
    ScoresIndex,
  },
};
</script>
